import { API_BASE_URL } from '../constants';

export interface User {
  id: string;
  phoneNumber: string;
  name?: string;
}

export const sendOTP = async (phoneNumber: string): Promise<{ requestId: string }> => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/send-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber }),
    });

    if (!response.ok) {
      throw new Error('Failed to send OTP');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
};

export const verifyOTP = async (requestId: string, otp: string, phoneNumber: string): Promise<User> => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/verify-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ requestId, otp, phoneNumber }),
    });

    if (!response.ok) {
      throw new Error('Invalid OTP');
    }

    const data = await response.json();
    
    // Validate user data before storing
    if (!data.user || !data.user.id || !data.user.phoneNumber) {
      throw new Error('Invalid user data received from server');
    }

    // Create a validated user object with only the fields we need
    const validatedUser: User = {
      id: data.user.id,
      phoneNumber: data.user.phoneNumber,
      name: data.user.name || undefined // Only include name if it exists
    };

    // Store the validated user data
    localStorage.setItem('minto_user', JSON.stringify(validatedUser));
    return validatedUser;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
};

export const isLoggedIn = (): boolean => {
  try {
    const userStr = localStorage.getItem('minto_user');
    if (!userStr) return false;

    const user = JSON.parse(userStr);
    // Validate the stored user data
    return !!(user && user.id && user.phoneNumber);
  } catch (error) {
    console.error('Error checking login status:', error);
    return false;
  }
};

export const getCurrentUser = (): User | null => {
  try {
    const userStr = localStorage.getItem('minto_user');
    if (!userStr) return null;

    const user = JSON.parse(userStr);
    // Validate the stored user data
    if (!user || !user.id || !user.phoneNumber) {
      localStorage.removeItem('minto_user'); // Clear invalid data
      return null;
    }

    return user;
  } catch (error) {
    console.error('Error getting current user:', error);
    localStorage.removeItem('minto_user'); // Clear invalid data
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem('minto_user');
}; 